
import { UserInfo } from "@/types/strategy-types";
import { useAdminUsers } from "@/hooks/admin/useAdminUsers";

export const useAdminUserManagement = () => {
  // User management hooks
  const { 
    users, 
    loading: usersLoading, 
    loadUsers,
    updateUserRole,
    updateUserName,
    deleteUser,
    sortField,
    sortOrder,
    handleSort
  } = useAdminUsers();

  // Helper function for getting users
  const getUsersForProviders = (): UserInfo[] => {
    return users.map(user => ({
      id: user.id,
      email: user.email || '',
      role: user.role,
      first_name: user.first_name,
      last_name: user.last_name,
      created_at: user.created_at
    }));
  };

  return {
    users,
    usersLoading,
    loadUsers,
    updateUserRole,
    updateUserName,
    deleteUser,
    sortField,
    sortOrder,
    handleSort,
    getUsersForProviders
  };
};
